import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { ProgramService } from "../../../shared/services/program.service";
import { Session } from "../../../models/program/session";
import { ProgramWithSessions } from "../../../models/program/program-with-sessions";

import { ISubscription } from "rxjs/Subscription";

const DEFAULT_VISIBLE_ROWS = 2;

@Component({
  selector: "app-sessions",
  templateUrl: "./sessions.component.html",
  styleUrls: ["./sessions.component.less"],
  providers: [],
})
export class SessionsComponent implements OnInit, OnDestroy {
  sessions: Session[];
  programs: ProgramWithSessions[];
  retiredPrograms: ProgramWithSessions[];
  currentPrograms: ProgramWithSessions[];
  sessionsSub: ISubscription;
  programsSub: ISubscription;
  isActive: string;
  minimalStateObj: { categoryType: string; mapping: string };
  expandedPrograms: number[] = [];

  constructor(private router: Router, private programService: ProgramService) {}

  ngOnInit(): void {
    this.minimalStateObj = { categoryType: "edition", mapping: "session" };
    this.isActive = "programs";
    this.subscribeToGetPrograms();
    this.subscribeToGetSessions();
    console.log;
  }

  subscribeToGetPrograms(): void {
    this.programsSub = this.programService
      .getProgramsWithSessions(true)
      .subscribe((programs) => {
        this.programs = programs;
        this.currentPrograms = programs.filter(p => !p.is_retired);
        this.retiredPrograms = programs.filter(p => p.is_retired);
      });
  }

  subscribeToGetSessions(): void {
    this.sessionsSub = this.programService
      .getSessionsSchedule(true)
      .subscribe((sessions) => {
        this.sessions = sessions;
      });
  }

  ngOnDestroy(): void {
    this.programsSub.unsubscribe();
    this.sessionsSub.unsubscribe();
  }

  get now(): string {
    let now: Date = new Date(Date.now());
    let month: string = this.formatDateTime(now.getMonth() + 1);
    let day: string = this.formatDateTime(now.getDate());
    let hour: string = this.formatDateTime(now.getHours());
    let minutes = "00";
    let seconds = "00";
    let dateString: any = `${now.getFullYear()}-${month}-${day}`;
    let timeString: any = `${hour}:${minutes}`;
    return `${dateString}T${timeString}:${seconds}`;
  }

  formatDateTime(int: number): string {
    let measure: string;
    if (int < 10) {
      measure = `0${int}`;
    } else {
      measure = int.toString();
    }
    return measure;
  }

  rowsToShow(program: ProgramWithSessions) {
    return this.expandedPrograms.indexOf(program.id) > -1
      ? program.sessions.length
      : DEFAULT_VISIBLE_ROWS;
  }

  moreRowsCount(program: ProgramWithSessions) {
    return Math.max(0, program.sessions.length - DEFAULT_VISIBLE_ROWS);
  }

  expandRows(program: ProgramWithSessions) {
    this.expandedPrograms.push(program.id);
    return false;
  }

  collapseRows(program: ProgramWithSessions) {
    for (;;) {
      const index = this.expandedPrograms.indexOf(program.id);
      if (index >= 0) {
        delete this.expandedPrograms[index];
      } else {
        break;
      }
    }
    return false;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/sessions/sessions.component.ts